<app-formulario #ctrl URL="estructura-documentos" titulo="Documentos / Catalogos" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar();  ctrl.cambiar_sucursal();">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section> 

                <section class="section" style="padding: 2rem 2rem !important; overflow:auto; height: 87.2vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a (click)="ctrl.cargarCatalogo('niveles_educativos', 'nivel-educativo'); ctrl.cargarCatalogo('tipos_periodos', 'tipo-periodo'); ctrl.subir['logo'] = false" id="catalogos"></a>

                    <a id="catalogos" (click)="ctrl.subir['logo'] = false;"></a>
                    <div class="columns">

                         <div class="column is-4">
                            <label class="label">Tipo Documento:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('tipo_documento').hasError('required')}">
                                        <select class="select" name="tipo_documento" formControlName="tipo_documento">
                                            <option value="BOLETA"> BOLETA </option>
                                            <option value="REGISTRO_ESCOLAR"> REGISTRO ESCOLAR </option>
                                            <option value="HISTORIAL_ACADEMICO"> HISTORIAL ACADEMICO </option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('tipo_documento').hasError('required')">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('tipo_documento').hasError('required')">
                                        Este campo es requerido.</span>
                                </div> 
                        </div>

                         <div class="column is-4">
                            <label class="label">Nivel educativo:</label>
                            <div class="control has-icons-left has-icons-right">
                                <ng-select2
                                (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.niveles_educativos_id)"
                                [data]="ctrl.niveles_educativos"
                                [disabled]="ctrl.niveles_educativos ? ctrl.niveles_educativos.length == 0 ? true : false : true"
                                [options]="ctrl.optionSelect"
                                [value]="ctrl.dato.controls.niveles_educativos_id.value"
                                name="niveles_educativos_id">
                                </ng-select2>

                                <span *ngIf="ctrl.dato.get('niveles_educativos_id').hasError('required')" class="icon is-small is-right">
                                <i class="fa fa-warning"></i>
                                </span>
                                <span *ngIf="ctrl.dato.get('niveles_educativos_id').hasError('required')" class="help is-danger">
                                Este campo es requerido.
                                </span>
                            </div>
                        </div>


                        <div class="column is-4">
                            <label class="label">Categoria:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select" [ngClass]="{'is-danger': ctrl.dato.get('tipo_rvoe').hasError('required')}">
                                        <select class="select" name="tipo_rvoe" formControlName="tipo_rvoe">
                                            <option value="ESTATAL"> ESTATAL </option>
                                            <option value="FEDERAL"> FEDERAL </option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('tipo_rvoe').hasError('required')">
                                        Este campo es requerido.</span>
                                </div> 
                        </div>
                        <!--
                        <div class="column is-3">
                            <label class="label">Nivel educativo:</label>
                            <div class="control has-icons-left has-icons-right">
                                <ng-select2 (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.nivel_educativo)" [data]="ctrl.niveles_educativos" [disabled]="ctrl.niveles_educativos ? ctrl.niveles_educativos.length == 0 ? true : false : true" [options]="ctrl.optionSelect"
                                    [value]="ctrl.dato.controls.nivel_educativo.value" name="nivel_educativo"></ng-select2>
                                <span *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')" class="icon is-small is-right">
                                                    <i class="fa fa-warning"></i>
                                                </span>
                                <span *ngIf="ctrl.dato.get('nivel_educativo').hasError('required')" class="help is-danger">Este campo es requerido.</span>
                            </div>
                        </div>-->


                    </div>
                    <div class="columns">

                        <div class="column is-8">
                            <div class="field">
                                <label class="label">Descripcion:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" placeholder="Descripcion" formControlName="nombre">
                                </div>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field">
                                <label class="label">Activo:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="b-checkbox is-info">
                                        <input id="autoPlay" class="styled" type="checkbox" formControlName="activo">
                                        <label for="autoPlay">
                                            Activo
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div class="columns">
                        <div class="column is-12">
                            <section class="hero" style="background:gainsboro">
                                <div class="hero-body" style="padding: 0.5rem 1.5rem;">
                                    <p class="title">
                                        <span class="icon is-medium ng-star-inserted">
                      <i class="icon-file22"></i>
                    </span> Estructuras


                                        <button class="navbar-item  is-success tooltip" type="button" (click)="ctrl.agregar_form_array(ctrl.dato.controls.documentos_estructuras, form_documentos_estructuras)" style="float: right;">
                      <span class="icon fa-2x has-text-success">
                        <i class="icon-add2"></i>
                      </span>
                      <span class="tooltiptext">Agregar</span>
                    </button>

                                    </p>

                                </div>
                            </section>
                            <div class="tabs is-boxed">
                                <ul>
                                    <li *ngFor="let modul of ctrl.dato.controls.documentos_estructuras.controls; let im = index" [ngClass]="{ 'is-active' : tab == im}">
                                        <a (click)="tab=im">
                                            <span class="icon ">
                        <i class="icon-file22"></i>
                      </span>
                                            <span>Estructura {{im + 1}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div formArrayName="documentos_estructuras" *ngIf="ctrl.dato.controls.documentos_estructuras.length > 0">
                                <div *ngFor="let estructura of ctrl.dato.controls.documentos_estructuras.controls; let im = index" [formGroupName]="im" [ngClass]="{ 'is-hidden': tab != im}">

                                    <div class="columns">
                                        <div class="column is-3">
                                            <label class="label">Tipo:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select" [ngClass]="{'is-danger': estructura.controls.tipo.hasError('required')}">
                                                    <select class="select" formControlName="tipo">
                            <option value="">Seleccione</option>
                            <option value="HEADER">HEADER</option>
                            <option value="FOOTER">FOOTER</option>
                            <option value="BODY">BODY</option>
                          </select>
                                                </div>
                                                <span class="help is-danger" *ngIf="estructura.controls.tipo.hasError('required') ">Este
                          campo es requerido.</span>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Filas:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <input class="input" type="number" min="1" max="99" [ngClass]="{'is-danger': estructura.controls.filas.hasError('required')}" placeholder="Filas" formControlName="filas">
                                            </div>
                                            <span class="help is-danger" *ngIf="estructura.controls.filas.hasError('required') ">Este campo
                        es requerido.</span>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Columnas:</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <input class="input" type="number" min="1" max="99" [ngClass]="{'is-danger': estructura.controls.columnas.hasError('required')}" placeholder="Columnas" formControlName="columnas">
                                            </div>
                                            <span class="help is-danger" *ngIf="estructura.controls.columnas.hasError('required') ">Este
                        campo es requerido.</span>
                                        </div>

                                        <div class="column is-1">
                                            <label class="label">&nbsp;</label>
                                            <div class="">

                                                <button class="navbar-item  tooltip" type="button" (click)="ctrl.quitar_form_array(ctrl.dato.controls.documentos_estructuras, im)" style="float: right;">
                          <span class="icon fa-2x has-text-danger">
                            <i class="icon-trash"></i>
                          </span>
                          <span class="tooltiptext">Quitar</span>
                        </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns">
                                        <div class="column is-12">
                                            <section class="hero" style="background:gainsboro">
                                                <div class="hero-body" style="padding: 0.5rem 1.5rem;">
                                                    <p class="title">
                                                        <span class="icon is-medium ng-star-inserted">
                                <i class="icon-file22"></i>
                              </span> Contenido


                                                        <button class="navbar-item  is-success tooltip" type="button" (click)="ctrl.agregar_form_array(estructura.controls.estructuras_contenidos, form_estructuras_contenidos)" style="float: right;">
                                <span class="icon fa-2x has-text-success">
                                  <i class="icon-add2"></i>
                                </span>
                                <span class="tooltiptext">Agregar</span>
                              </button>

                                                    </p>

                                                </div>
                                            </section>
                                            <div class="tabs is-boxed">
                                                <ul>
                                                    <li *ngFor="let contenido of estructura.controls.estructuras_contenidos.controls; let im2 = index" [ngClass]="{ 'is-active' : tab2[im] == im2}">
                                                        <a (click)="tab2[im]=im2">
                                                            <span class="icon ">
                                  <i class="icon-file"></i>
                                </span>
                                                            <span>Contenido {{im2 + 1}}</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div formArrayName="estructuras_contenidos" *ngIf="estructura.controls.estructuras_contenidos.length > 0">
                                                <div *ngFor="let contenido of estructura.controls.estructuras_contenidos.controls; let im2 = index" [formGroupName]="im2" [ngClass]="{ 'is-hidden': tab2[im] != im2}">

                                                    <div class="columns">
                                                        <div class="column is-3">
                                                            <label class="label">Tipo:</label>
                                                            <div class="control has-icons-left has-icons-right">
                                                                <div class="select">
                                                                    <select class="select" formControlName="tipo">
                                      <option value="">Seleccione</option>
                                      <option value="FOTO" [selected]="contenido.get('contenido') == '' || contenido.get('tipo').value == 'FOTO'">FOTO</option>
                                      <option value="CONTENIDO" [selected]="contenido.get('path_imagen') == '' || contenido.get('tipo').value == 'CONTENIDO'">CONTENIDO</option>
                                    </select>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <div class="column is-2">
                                                            <label class="label">Fila:</label>
                                                            <div class="control has-icons-left has-icons-right">
                                                                <input class="input" type="number" min="1" max="99" [ngClass]="{'is-danger': contenido.controls.fila.hasError('required')}" placeholder="Fila" formControlName="fila">
                                                            </div>
                                                            <span class="help is-danger" *ngIf="contenido.controls.fila.hasError('required') ">Este
                                  campo es requerido.</span>
                                                        </div>

                                                        <div class="column is-2">
                                                            <label class="label">Columna:</label>
                                                            <div class="control has-icons-left has-icons-right">
                                                                <input class="input" type="number" min="1" max="99" [ngClass]="{'is-danger': contenido.controls.columna.hasError('required')}" placeholder="Columna" formControlName="columna">
                                                            </div>
                                                            <span class="help is-danger" *ngIf="contenido.controls.columna.hasError('required') ">Este
                                  campo es
                                  requerido.</span>
                                                        </div>

                                                        <div class="column is-2">
                                                            <label class="label">Ancho porcentaje:</label>
                                                            <div class="control has-icons-left has-icons-right">
                                                                <input class="input" type="number" min="1" max="100" [ngClass]="{'is-danger': contenido.controls.ancho_porcentaje.hasError('required')}" placeholder="Ancho" formControlName="ancho_porcentaje">
                                                            </div>
                                                            <span class="help is-danger" *ngIf="contenido.controls.ancho_porcentaje.hasError('required') ">Este
                                  campo es
                                  requerido.</span>
                                                        </div>

                                                        <div class="column is-2">
                                                            <label class="label">Alto porcentaje:</label>
                                                            <div class="control has-icons-left has-icons-right">
                                                                <input class="input" type="number" min="1" max="100" [ngClass]="{'is-danger': contenido.controls.alto_porcentaje.hasError('required')}" placeholder="Alto" formControlName="alto_porcentaje">
                                                            </div>
                                                            <span class="help is-danger" *ngIf="contenido.controls.alto_porcentaje.hasError('required') ">Este
                                  campo es
                                  requerido.</span>
                                                        </div>

                                                        <div class="column is-1">
                                                            <label class="label">&nbsp;</label>
                                                            <div class="">

                                                                <button class="navbar-item  tooltip" type="button" (click)="ctrl.quitar_form_array(estructura.controls.estructuras_contenidos, im2)" style="float: right;">
                                    <span class="icon fa-2x has-text-danger">
                                      <i class="icon-trash"></i>
                                    </span>
                                    <span class="tooltiptext">Quitar</span>
                                  </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="columns">
                                                        <div class="column is-12">
                                                            <div class="box" *ngIf="contenido.get('tipo').value == 'FOTO'">
                                                                <article class="media">
                                                                    <div class="media-left">
                                                                        <figure class="image is-64x64">   

                                                                           <!-- <img *ngIf="ctrl.subir['logo'+im2]" [src]="'data:image/jpeg;base64,'+contenido.get('path_imagen').value">-->
                                                                           
                                                                           <!--<img *ngIf="ctrl.subir['logo'+im2]" [src]="safeImage(contenido.get('path_imagen').value)">-->
                                                                           <img *ngIf="ctrl.subir && ctrl.subir['logo'+im2]" [src]="safeImage(ctrl.subir['logo'+im2])">


                                                                           <!-- <img *ngIf="ctrl.subir['logo'+im2]" [src]="ctrl.safeImage(contenido.get('path_imagen').value)"> -->
                                                                           <!--<img *ngIf="ctrl && ctrl.subir && ctrl.subir['logo'+im2]" [src]="ctrl?.safeImage(contenido.get('path_imagen').value)">-->
                                                                           <!--<img *ngIf="ctrl && ctrl.subir && !ctrl.subir['logo'+im2]"
                                                                            [src]="contenido.get('path_imagen').value != '' 
                                                                            ? ctrl.API_PATH + '/adjunto/documentos/' + contenido.controls.path_imagen.value  
                                                                            : './assets/128x128.png'">-->




                                                                            <img *ngIf="!ctrl.subir['logo'+im2]" [src]="contenido.get('path_imagen').value != '' ? ctrl.API_PATH + '/adjunto/documentos/' + contenido.controls.path_imagen.value  : './assets/128x128.png'">
                                                                        </figure>
                                                                    </div>
                                                                    <div class="media-content">
                                                                        <div class="field">
                                                                            <label class="label">Logo:</label>
                                                                            <div class="control has-icons-left has-icons-right" *ngIf="contenido.get('path_imagen').value == ''">

                                                                                <div class="file has-name">
                                                                                    <label class="file-label">
                                              <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, contenido.controls.path_imagen, false, 'logo'+im2)"
                                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                              <span class="file-cta">
                                                <span class="file-icon">
                                                  <i class="fa fa-upload"></i>
                                                </span>
                                                <span class="file-label">
                                                  Seleccionar archivo
                                                </span>
                                              </span>

                                            </label>
                                                                                </div>
                                                                            </div>
                                                                            <input foto type="hidden" formControlName="path_imagen">
                                                                            <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, contenido.controls.path_imagen, 'documentos')" *ngIf="contenido.get('path_imagen').value != ''">
                                          <span class="icon">
                                            <i class="fa fa-trash"></i>
                                          </span>
                                          &nbsp; Eliminar logo.
                                        </button>
                                                                        </div>
                                                                    </div>
                                                                </article>
                                                            </div>

                                                            <ckeditor *ngIf="contenido.get('tipo').value == 'CONTENIDO'" formControlName="contenido" debounce="500" [config]="CkeditorConfig"></ckeditor>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>